import { type RefObject, useEffect } from 'react';

export function useOutsideClick(
  ref: RefObject<HTMLElement>,
  callback: Function,
  condition = true
) {
  useEffect(() => {
    if (condition) {
      function handleClickOutside(event: MouseEvent) {
        if (
          ref.current &&
          typeof ref.current.contains === 'function' &&
          !ref.current.contains(event.target as Node)
        ) {
          callback(event);
        }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [ref, callback, condition]);
}
